import { PageHeader, Skeleton, Typography } from "antd";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { getBranding } from "@Branding";

import CreditsBalance from "@Components/shared/CreditsBalance";
import Notifications from "@Components/shared/Notifications";
import { LoginMenu } from "./LoginMenu";
import { SkeletonRows } from "@Components/shared/SkeletonRows";
import Logo from "./Logo";

const { Text } = Typography;

/**
 * Render the page title based directly on the path name
 * @param pathname
 */
const renderPageTitle = (pathname: string) => {
    const parsedSearch = pathname.split("/")[1];
    if (parsedSearch.length === 0) return "Profile";

    return capitalize(parsedSearch.split("-")).join(" ");
};

/**
 * Capitalize the first letter of each word in the array and return as a single string
 * @param array
 */
const capitalize = (array: string[]) => {
    return array.map((word) => word.split("")[0].toUpperCase() + word.split("").splice(1).join(""));
};

interface IProps {
    skeleton?: boolean;
}

/**
 * Render the page header
 */
export const Header: React.FC<IProps> = ({ skeleton }: IProps) => {
    const location = useLocation();
    const { pathname } = location;
    const pageTitle = renderPageTitle(pathname);

    /**
     * Return a skeleton version of the site header.
     */
    const getSkeletonHeader = () => {
        return (
            <PageHeader
                className="main-layout-page-header"
                subTitle={<SkeletonRows count={1} rowHeight={50} />}
                extra={[
                    <Skeleton.Avatar active={true} size={32} shape={"circle"} />,
                    <Skeleton.Avatar active={true} size={32} shape={"circle"} />,
                ]}
                style={{
                    width: "calc(100vw - 205px)",
                    transition: "all 0.2s",
                    backgroundColor: getBranding("--brand-accent"),
                }}
            />
        );
    };

    return skeleton ? (
        getSkeletonHeader()
    ) : (
        <PageHeader
            className="main-layout-page-header"
            subTitle={<Text style={{ color: "white", fontSize: "25px", marginLeft: "18px" }}>{pageTitle}</Text>}
            title={<StyledLogo />}
            extra={[
                <CreditsBalance key={"balance"} />,
                <Notifications key={"notifications"} />,
                <LoginMenu key={"login-root"} />,
            ]}
            style={{ transition: "all 0.2s", backgroundColor: getBranding("--brand-accent") }}
        />
    );
};

const StyledLogo = () => {
    const history = useHistory();
    return (
        <div
            className="main-logo-container"
            onClick={() => {
                history.push("/");
            }}
        >
            <Logo style={{ height: "80px", color: "white", scale: getBranding("main-page-logo-scale") }} />
        </div>
    );
};
